// src/components/12.js
import React from 'react';

const Componente12 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 12</h2>
      <p>
        Para una persona nacida el día 12, el número de propósito asociado sería 12.
      </p>
      <p>
        En numerología, el número 12 combina las energías del 1 (liderazgo) y el 2 (cooperación), sugiriendo que su propósito es equilibrar el liderazgo con la colaboración. El propósito de una persona nacida en el día 12 puede incluir:
      </p>
      <ul>
        <li><strong>Guiar desde la Colaboración:</strong> Estas personas tienen un propósito de liderar, pero siempre con un enfoque en la cooperación y el trabajo en equipo.</li>
        <li><strong>Desarrollar la Autoexpresión:</strong> El número 12 está relacionado con la creatividad y la autoexpresión, invitando a la persona a comunicar sus ideas de manera eficaz.</li>
        <li><strong>Inspirar a Otros:</strong> Tienen la capacidad de inspirar a través del ejemplo y de influir positivamente en los demás.</li>
        <li><strong>Encontrar el Equilibrio:</strong> Deben equilibrar sus deseos de autonomía con la necesidad de trabajar bien con otros.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 12</h3>
      <ul>
        <li><strong>Creativos:</strong> Tienen una gran creatividad y buscan maneras innovadoras de expresar sus ideas.</li>
        <li><strong>Equilibrados:</strong> Pueden encontrar el balance entre liderazgo y cooperación.</li>
        <li><strong>Comunicadores Eficaces:</strong> Son buenos para transmitir sus ideas y pensamientos.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 12 tienen un propósito centrado en liderar a través de la colaboración y la creatividad. Están llamadas a equilibrar su independencia con el trabajo en equipo, siendo líderes inspiradores y comunicadores efectivos.
      </p>
    </div>
  );
};

export default Componente12;
